module.exports = __webpack_public_path__ + "43587c8634bd805afa5ecc5cf59b1cb9.svg";